(function() {
    angular
        .module('maApp.remoteRequests')
        .factory('APIRequest', APIRequest);

    APIRequest.$inject = ['Auth', 'endpoint', '$http', '$interpolate', 'RequestError'];

    function APIRequest(Auth, endpoint, $http, $interpolate, RequestError){

        var MIMEType = {
            JSON:'application/json'
        };

        var JSONRequestHeader = {
            'Accept': MIMEType.JSON,
            'Content-Type': MIMEType.JSON
        };

        angular.extend(PBAPIRequest.prototype,{
            'modelUrl':modelUrl,
            'collectionUrl':collectionUrl
        });

        return {
            'MIMEType':angular.copy(MIMEType),
            'commonSucceed':commonSucceed,
            'createCommonFail':createCommonFail,
            'Request':PBAPIRequest,
            'get':httpGet,
            'post':httpPost,
            'put':httpPut,
            'delete':httpDelete
        };


        /**
         *
         * Creates request urls, provides common $http() parameters, and executes requests.
         * Use {{endpoint}} in template for api endpoint url.
         *
         * @param strCollectionUrlTemplate {string} Url template to the collection endpoint. Passed to $interpolate.
         * @param strModelUrlTemplate {string} Url template to the model endpoint. Passed to $interpolate.
         * @constructor
         */
        function PBAPIRequest(strCollectionUrlTemplate, strModelUrlTemplate){
            this.collectionUrlTemplate = $interpolate(strCollectionUrlTemplate);
            this.modelUrlTemplate = $interpolate(strModelUrlTemplate);
        }

        function modelUrl(urlAgruments){
            urlAgruments = urlAgruments || {};
            return this.modelUrlTemplate(angular.extend(commonTemplateOptions(), urlAgruments));
        }

        function collectionUrl(urlArguments){
            urlArguments = urlArguments || {};
            return this.collectionUrlTemplate(angular.extend(commonTemplateOptions(), urlArguments));
        }

        function commonHeader(){
            return angular.copy(JSONRequestHeader);
        }

        function commonAuthHeader(){
            return angular.extend({}, JSONRequestHeader, {'Authorization':Auth.getAuthorizationHeader()});
        }

        function commonTemplateOptions(){
            return {
                'endpoint':endpoint
            };
        }

        function commonSucceed(response){
            return response.data;
        }

        function createCommonFail(msg){
            return function(response){
                throw new RequestError(response, msg);
            }
        }

        function $httpRequest(method, config, options){
            options = options || {};
            config.headers = config.headers || {};
            var useAuth = ('auth' in options) ? options.auth : true;
            if(useAuth){
                config.headers.Authorization = Auth.getAuthorizationHeader();
            }
            config.headers.Accept = config.headers.Accept || MIMEType.JSON;
            if(method != 'GET'){
                config.headers['Content-Type'] = config.headers['Content-Type'] || MIMEType.JSON;
            }
            return $http(angular.extend(config, {'method':method}));
        }

        function httpGet(config, options){
            return $httpRequest('GET', config, options);
        }

        function httpPost(config, options){
            return $httpRequest('POST', config, options);
        }

        function httpPut(config, options){
            return $httpRequest('PUT', config, options);
        }

        function httpDelete(config, options){
            return $httpRequest('DELETE', config, options);
        }
    }
})();